import {type AnyObject} from '@wix/wixstores-client-core';
import {getAppVersion} from '@wix/wixstores-client-core/dist/src/app-version/appVersion';

function getTranslationsForVersionAndLocale(version: string, locale: string) {
  return `https://static.parastorage.com/services/wixstores-client-worker/${version}/assets/locale/editorWorker/editorWorker_${locale}.json`;
}

export const replacePlaceholders = (translation: string, values: AnyObject) => {
  let result = translation;
  Object.entries(values).forEach(([key, value]) => {
    const placeholder = `{{${key}}}`;
    result = result.replace(new RegExp(placeholder, 'g'), String(value));
  });
  return result;
};

export async function translateFunctionFactory(locale: string) {
  const version = getAppVersion();
  const translationsJson = await (await fetch(getTranslationsForVersionAndLocale(version, locale))).json();

  return (keyToTranslate: string, values?: AnyObject) => {
    const translation: string = translationsJson[keyToTranslate];

    return values ? replacePlaceholders(translation, values) : translation;
  };
}
